import BASIC from './basic';

const Apple = {
  ...BASIC,
};

export default Apple;
